var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('textarea',{staticClass:"simple-textarea",attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value || ''},on:{"input":(e) => _vm.$emit('input', e.target.value)}}),(_vm.error)?_c('div',{staticClass:"simple-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }